import React, { lazy, Suspense } from "react";
import Spinner from "../component/page/loading/spinner";

const Navbar = lazy(() => import("./navbar"));

const NavbarWrapper = ({ children, showNavbar }) => {
  return (
    <Suspense fallback={<div><Spinner /></div>}>
      {showNavbar && <Navbar />}
      {/* 👇 Spacer to prevent content from hiding behind fixed navbar */}
      <div className="h-[69px] md:h-[69px]"></div>
      {children}
    </Suspense>
  );
};

export default NavbarWrapper;